import { render, staticRenderFns } from "./not-found.page.vue?vue&type=template&id=8bcfd5cc&scoped=true&"
import script from "./not-found-page.js?vue&type=script&lang=js&"
export * from "./not-found-page.js?vue&type=script&lang=js&"
import style0 from "./not-found-page.scss?vue&type=style&index=0&id=8bcfd5cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcfd5cc",
  null
  
)

export default component.exports